import { Instant } from "@/temporal"
import { objectSchema } from "vue-utils"
import { Id, Nullable } from "./GenericEntity"
import { User } from "./User"

export interface UserTimeStamp {
	userId: Id
	timeStamp: Instant
	user: Nullable<User>
}

export const UserTimeStamp = objectSchema<UserTimeStamp>({
	userId: Id,
	timeStamp: Instant.Schema,
	user: Nullable(User),
})
